import React from 'react';
import styled from 'styled-components';

export const TopBar: React.FC = () => <StyledToolbar />;

const StyledToolbar = styled.div`
  border-top: ${(props) => props.theme.pxToRem(10)} solid #2666cf;
`;
